import { render, staticRenderFns } from "./ExpensesLanding.vue?vue&type=template&id=9b4860ec&scoped=true&"
import script from "./ExpensesLanding.vue?vue&type=script&lang=js&"
export * from "./ExpensesLanding.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesLanding.vue?vue&type=style&index=0&id=9b4860ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4860ec",
  null
  
)

export default component.exports